import { DEFAULT_TEXT_STYLE, chartColorPalette } from '../ChartWidget.config';
import { extendSeriesData } from '../ChartWidget.helpers';
import { ChartDataSeries } from '../ChartWidget.types';

const DEFAULT_WIDTH = 476;
const DEFAULT_HEIGHT = 315;

const DEFAULT_FONT_FAMILY = 'Inter';
const DEFAULT_NUMBER_FORMAT = 'value';
const DEFAULT_BORDER_WIDTH = 2;
const DEFAULT_BORDER_COLOR = '#FFF';
const DEFAULT_CONNECTOR_WIDTH = 1;
const MIN_LINE_CONNECTOR_WIDTH = 0;
const MAX_LINE_CONNECTOR_WIDTH = 20;
const DISABLED_LINE_CONNECTOR_OFFSET = -15;
const DEFAULT_PYRAMID_CHART_DATA = {
  legend: {
    enabled: false,
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  title: {
    text: 'Sales pyramid',
    x: -50,
  },
  dataLabels: {
    enabled: true,
    style: {
      ...DEFAULT_TEXT_STYLE,
      fontFamily: DEFAULT_FONT_FAMILY,
      color: 'contrast',
    },
    connectorWidth: 1,
    inside: false,
  },
  seriesData: extendSeriesData([
    {
      name: 'Category',
      data: ['Purchase', 'Product', 'Checkout', 'Register'],
    },
    {
      name: 'Value',
      data: [300, 650, 850, 1000],
    },
  ] as ChartDataSeries),
  seriesMeta: {
    colors: chartColorPalette,
  },
  xAxis: {
    title: {
      text: '',
      style: {
        ...DEFAULT_TEXT_STYLE,
      },
    },
    style: {
      lineColor: '#000000',
      lineWidth: 1,
    },
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  yAxis: {
    title: {
      text: '',
      style: {
        ...DEFAULT_TEXT_STYLE,
      },
    },
    style: {
      lineColor: '#000000',
      lineWidth: 1,
    },
    enableLine: false,
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  grid: {
    style: {
      lineColor: '#DBDBDB',
    },
  },
  generalOptions: {
    innerSize: 0,
    borderWidth: DEFAULT_BORDER_WIDTH,
    borderColor: DEFAULT_BORDER_COLOR,
  },
  patterns: {
    enabled: false,
    list: [],
  },
};

export {
  DEFAULT_BORDER_COLOR,
  DEFAULT_BORDER_WIDTH,
  DEFAULT_CONNECTOR_WIDTH,
  DEFAULT_HEIGHT,
  DEFAULT_NUMBER_FORMAT,
  DEFAULT_PYRAMID_CHART_DATA,
  DEFAULT_WIDTH,
  DISABLED_LINE_CONNECTOR_OFFSET,
  MAX_LINE_CONNECTOR_WIDTH,
  MIN_LINE_CONNECTOR_WIDTH,
};
